import { User, UserApiResponse } from 'types/user'

export function normalizeUser(user: UserApiResponse): User {
    const {
        id,
        cognitoId,
        email,
        firstName: first_name,
        lastName: last_name,
        gender,
        street1: street_1,
        street2: street_2,
        zip,
        city,
        country,
        preferredLanguage: lang,
        imageUrl: image_url,
    } = user as unknown as Record<string, string>
    return {
        id,
        email,
        first_name,
        last_name,
        cognitoId,
        gender,
        lang,
        image_url,
        street_1,
        street_2,
        zip,
        country,
        phone: user.phone as unknown as string,
    }
}
